module.exports = __webpack_public_path__ + "img/icon_4_2.b48f385a.png";